import { render, staticRenderFns } from "./MForm.vue?vue&type=template&id=8bc5a808"
import script from "./MForm.vue?vue&type=script&lang=js"
export * from "./MForm.vue?vue&type=script&lang=js"
import style0 from "./MForm.vue?vue&type=style&index=0&id=8bc5a808&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports